import "./Recon.css";
import Pagination from "./Pagination";
import { useSelector } from "react-redux";

function ReconTable({
  dataItem,
  userData,
  setCurrentPage,
  currentPage,
  pagesData,
  startDate,
  endDate,
  getReconciliationData,
}) {
  const role = useSelector((store) => store.userReducer.role);

  return (
    <div className="table-main-report">
      <table className="table-user-management" id="transaction-table">
        <thead className="table-user-report">
          <tr>
            {(role == "super" ||
              role === "operation" ||
              role === "compliance" ||
              role === "subSuper") && (
              <td>
                <p className="user-table-head-report">Business Name</p>
              </td>
            )}

            <td>
              <p className="user-table-head-report">OrderId</p>
            </td>
            <td>
              <p className="user-table-head-report">TransactionId</p>
            </td>
            <td>
              <p className="user-table-head-report">Amount(₹)</p>
            </td>
            <td>
              <p className="user-table-head-report">Transaction Date</p>
            </td>
            <td>
              <p className="user-table-head-report">Updated Date</p>
            </td>
            <td>
              <p className="user-table-head-report">Penalty</p>
            </td>
            <td>
              <p className="user-table-head-report">Status</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {dataItem &&
            dataItem.length > 0 &&
            dataItem.map((item, i) => {
              const dateString = item.createdAt;
              const date = new Date(dateString);
              const day = date.getDate();
              const month = date.getMonth() + 1;
              const year = date.getFullYear();
              const hours = date.getHours();
              const minutes = date.getMinutes();
              const seconds = date.getSeconds();
              const formattedDate = `${day}-${month}-${year}`;
              const formattedTime = `${hours}:${minutes}:${seconds}`;
              return (
                <tr key={i} className="user-table-head-report">
                  {(role === "super" ||
                    role === "operation" ||
                    role === "compliance" ||
                    role === "subSuper") && (
                    <td>
                      <p className="table-user-data-report order-break">
                        {userData &&
                          userData.length > 0 &&
                          userData
                            .map((user) =>
                              user.id === item.userId
                                ? user?.alias || user?.id
                                : null
                            )
                            .filter((name) => name)}{" "}
                      </p>
                    </td>
                  )}
                  <td>
                    <p className="table-user-data-report order-break">
                      {item?.orderId}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {item?.transactionId}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {Number(item?.amount).toFixed(2) || "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {formattedDate} {formattedTime}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {(() => {
                        const date = new Date(item.updatedAt);
                        const formattedDate = `${date.getDate()}-${
                          date.getMonth() + 1
                        }-${date.getFullYear()}`;
                        const formattedTime = `${date
                          .getHours()
                          .toString()
                          .padStart(2, "0")}:${date
                          .getMinutes()
                          .toString()
                          .padStart(2, "0")}:${date
                          .getSeconds()
                          .toString()
                          .padStart(2, "0")}`;
                        return `${formattedDate} ${formattedTime}`;
                      })()}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {Number(item?.penalty).toFixed(2) || "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report-1">
                      {item.status == false ? "Pending" : "Completed"}
                    </p>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {dataItem?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pagesData={pagesData}
          startDate={startDate}
          endDate={endDate}
          getReconciliationData={getReconciliationData}
        />
      )}
    </div>
  );
}

export default ReconTable;
